// ── Colours data ─────────────────────────────────────────────────────────────
// Single source of truth for all colour entries and fun facts used in
// the Colours Explorer, Swatch Playground, Inspector, and Quiz sections.

export const GROUPS = [
  "All",
  "Primary",
  "Secondary",
  "Warm",
  "Cool",
  "Neutral",
  "Dark",
  "Pastel",
  "Earth",
  "Metallic",
  "Fluorescent",
  "Monochrome",
  "Ocean",
  "Forest",
  "Sunset",
  "Candy",
  "Galaxy",
];

export const COLOURS = [
  // [Primary]
  { name: "Red", hex: "#e53935", group: "Primary" },
  { name: "Blue", hex: "#1e88e5", group: "Primary" },
  { name: "Yellow", hex: "#fdd835", group: "Primary" },
  { name: "Green", hex: "#43a047", group: "Primary" },
  { name: "Orange", hex: "#fb8c00", group: "Primary" },
  { name: "Purple", hex: "#8e24aa", group: "Primary" },
  { name: "Cyan", hex: "#00acc1", group: "Primary" },
  { name: "Magenta", hex: "#d81b60", group: "Primary" },
  { name: "Lime", hex: "#cddc39", group: "Primary" },
  { name: "Indigo", hex: "#3949ab", group: "Primary" },

  // [Secondary]
  { name: "Teal", hex: "#00897b", group: "Secondary" },
  { name: "Amber", hex: "#ffb300", group: "Secondary" },
  { name: "Violet", hex: "#7c3aed", group: "Secondary" },
  { name: "Turquoise", hex: "#1de9b6", group: "Secondary" },
  { name: "Rose", hex: "#f48fb1", group: "Secondary" },
  { name: "Sky Blue", hex: "#81d4fa", group: "Secondary" },
  { name: "Mint", hex: "#a5d6a7", group: "Secondary" },
  { name: "Peach", hex: "#ffcc80", group: "Secondary" },
  { name: "Lilac", hex: "#b39ddb", group: "Secondary" },
  { name: "Coral", hex: "#ff7043", group: "Secondary" },

  // [Warm]
  { name: "Crimson", hex: "#c62828", group: "Warm" },
  { name: "Scarlet", hex: "#d32f2f", group: "Warm" },
  { name: "Tomato", hex: "#f44336", group: "Warm" },
  { name: "Rust", hex: "#b74c1a", group: "Warm" },
  { name: "Saffron", hex: "#f4c430", group: "Warm" },
  { name: "Tangerine", hex: "#f28500", group: "Warm" },
  { name: "Marigold", hex: "#eaa221", group: "Warm" },
  { name: "Maroon", hex: "#800000", group: "Warm" },
  { name: "Vermilion", hex: "#e34234", group: "Warm" },
  { name: "Fire", hex: "#ff5722", group: "Warm" },

  // [Cool]
  { name: "Navy", hex: "#1a237e", group: "Cool" },
  { name: "Cobalt", hex: "#0047ab", group: "Cool" },
  { name: "Cerulean", hex: "#007ba7", group: "Cool" },
  { name: "Periwinkle", hex: "#ccccff", group: "Cool" },
  { name: "Sapphire", hex: "#0f52ba", group: "Cool" },
  { name: "Ice Blue", hex: "#d0f0fd", group: "Cool" },
  { name: "Steel Blue", hex: "#4682b4", group: "Cool" },
  { name: "Arctic", hex: "#e0f7fa", group: "Cool" },
  { name: "Lagoon", hex: "#4cb5f5", group: "Cool" },
  { name: "Deep Sea", hex: "#003f5c", group: "Cool" },

  // [Neutral]
  { name: "Beige", hex: "#f5f5dc", group: "Neutral" },
  { name: "Ivory", hex: "#fffff0", group: "Neutral" },
  { name: "Cream", hex: "#fffdd0", group: "Neutral" },
  { name: "Khaki", hex: "#c3b091", group: "Neutral" },
  { name: "Sand", hex: "#c2b280", group: "Neutral" },
  { name: "Taupe", hex: "#8b8589", group: "Neutral" },
  { name: "Caramel", hex: "#c68e17", group: "Neutral" },
  { name: "Tan", hex: "#d2b48c", group: "Neutral" },
  { name: "Wheat", hex: "#f5deb3", group: "Neutral" },
  { name: "Mushroom", hex: "#b8a99a", group: "Neutral" },

  // [Dark]
  { name: "Black", hex: "#000000", group: "Dark" },
  { name: "Charcoal", hex: "#36454f", group: "Dark" },
  { name: "Slate", hex: "#2f4f4f", group: "Dark" },
  { name: "Midnight", hex: "#191970", group: "Dark" },
  { name: "Ebony", hex: "#555d50", group: "Dark" },
  { name: "Burgundy", hex: "#800020", group: "Dark" },
  { name: "Forest", hex: "#0b6623", group: "Dark" },
  { name: "Olive", hex: "#556b2f", group: "Dark" },
  { name: "Graphite", hex: "#3b3b3b", group: "Dark" },
  { name: "Onyx", hex: "#353839", group: "Dark" },

  // [Pastel]
  { name: "Pastel Pink", hex: "#ffd1dc", group: "Pastel" },
  { name: "Pastel Blue", hex: "#aec6cf", group: "Pastel" },
  { name: "Pastel Green", hex: "#c1e1c1", group: "Pastel" },
  { name: "Pastel Yellow", hex: "#fdfd96", group: "Pastel" },
  { name: "Pastel Purple", hex: "#c3b1e1", group: "Pastel" },
  { name: "Pastel Orange", hex: "#ffb347", group: "Pastel" },
  { name: "Pastel Mint", hex: "#d5f4e6", group: "Pastel" },
  { name: "Pastel Rose", hex: "#f7c5cc", group: "Pastel" },
  { name: "Pastel Lavender", hex: "#e3e4fa", group: "Pastel" },
  { name: "Pastel Peach", hex: "#ffdab9", group: "Pastel" },

  // [Earth]
  { name: "Clay", hex: "#b66a50", group: "Earth" },
  { name: "Moss", hex: "#8a9a5b", group: "Earth" },
  { name: "Soil", hex: "#5a3e36", group: "Earth" },
  { name: "Terracotta", hex: "#e2725b", group: "Earth" },
  { name: "Stone", hex: "#a8a8a8", group: "Earth" },
  { name: "Driftwood", hex: "#a7988a", group: "Earth" },
  { name: "Clay Red", hex: "#a14d3a", group: "Earth" },
  { name: "Earth Brown", hex: "#7b4f3f", group: "Earth" },
  { name: "Harvest", hex: "#e1a95f", group: "Earth" },
  { name: "Mud", hex: "#6f4e37", group: "Earth" },

  // [Metallic]
  { name: "Silver", hex: "#c0c0c0", group: "Metallic" },
  { name: "Gold", hex: "#d4af37", group: "Metallic" },
  { name: "Bronze", hex: "#cd7f32", group: "Metallic" },
  { name: "Copper", hex: "#b87333", group: "Metallic" },
  { name: "Steel", hex: "#7f8c8d", group: "Metallic" },
  { name: "Platinum", hex: "#e5e4e2", group: "Metallic" },
  { name: "Titanium", hex: "#878787", group: "Metallic" },
  { name: "Iron", hex: "#a19d94", group: "Metallic" },
  { name: "Chrome", hex: "#d1d1d1", group: "Metallic" },
  { name: "Brass", hex: "#b5a642", group: "Metallic" },

  // [Fluorescent]
  { name: "Neon Yellow", hex: "#ccff00", group: "Fluorescent" },
  { name: "Neon Orange", hex: "#ff6600", group: "Fluorescent" },
  { name: "Neon Pink", hex: "#ff1493", group: "Fluorescent" },
  { name: "Neon Green", hex: "#39ff14", group: "Fluorescent" },
  { name: "Neon Blue", hex: "#1f51ff", group: "Fluorescent" },
  { name: "Neon Purple", hex: "#bc13fe", group: "Fluorescent" },
  { name: "Neon Red", hex: "#ff073a", group: "Fluorescent" },
  { name: "Neon Aqua", hex: "#00ffff", group: "Fluorescent" },
  { name: "Neon Lime", hex: "#bfff00", group: "Fluorescent" },
  { name: "Neon Magenta", hex: "#ff00ff", group: "Fluorescent" },

  // [Monochrome]
  { name: "White", hex: "#ffffff", group: "Monochrome" },
  { name: "Light Gray", hex: "#d3d3d3", group: "Monochrome" },
  { name: "Gray", hex: "#808080", group: "Monochrome" },
  { name: "Dark Gray", hex: "#505050", group: "Monochrome" },
  { name: "Jet", hex: "#343434", group: "Monochrome" },
  { name: "Ash", hex: "#b2beb5", group: "Monochrome" },
  { name: "Smoke", hex: "#738276", group: "Monochrome" },
  { name: "Shadow", hex: "#2e2e2e", group: "Monochrome" },
  { name: "Fog", hex: "#dcdcdc", group: "Monochrome" },
  { name: "Ink", hex: "#1b1b1b", group: "Monochrome" },

  // [Ocean]
  { name: "Wave", hex: "#5dade2", group: "Ocean" },
  { name: "Deep Ocean", hex: "#154360", group: "Ocean" },
  { name: "Coral Reef", hex: "#ff7f50", group: "Ocean" },
  { name: "Seafoam", hex: "#9fe2bf", group: "Ocean" },
  { name: "Tide", hex: "#1b4f72", group: "Ocean" },
  { name: "Blue Lagoon", hex: "#4cb5f5", group: "Ocean" },
  { name: "Abyss", hex: "#001f3f", group: "Ocean" },
  { name: "Foam", hex: "#f0f8ff", group: "Ocean" },
  { name: "Drift", hex: "#b0c4de", group: "Ocean" },
  { name: "Shell", hex: "#fff5ee", group: "Ocean" },

  // [Forest]
  { name: "Pine", hex: "#01796f", group: "Forest" },
  { name: "Leaf", hex: "#76b041", group: "Forest" },
  { name: "Fern", hex: "#4f7942", group: "Forest" },
  { name: "Spruce", hex: "#0a5f38", group: "Forest" },
  { name: "Cedar", hex: "#8b5a2b", group: "Forest" },
  { name: "Bark", hex: "#5c4033", group: "Forest" },
  { name: "Evergreen", hex: "#05472a", group: "Forest" },
  { name: "Moss Green", hex: "#8a9a5b", group: "Forest" },
  { name: "Wood", hex: "#deb887", group: "Forest" },
  { name: "Forest Mist", hex: "#e8f5e9", group: "Forest" },

  // [Sunset]
  { name: "Sunset Orange", hex: "#ff4500", group: "Sunset" },
  { name: "Sunset Pink", hex: "#ff6f61", group: "Sunset" },
  { name: "Sunset Purple", hex: "#8a2be2", group: "Sunset" },
  { name: "Sunset Yellow", hex: "#ffd700", group: "Sunset" },
  { name: "Sunset Red", hex: "#ff6347", group: "Sunset" },
  { name: "Dusk", hex: "#4b0082", group: "Sunset" },
  { name: "Twilight", hex: "#6a5acd", group: "Sunset" },
  { name: "Glow", hex: "#ffa07a", group: "Sunset" },
  { name: "Horizon", hex: "#ffdab9", group: "Sunset" },
  { name: "Evening", hex: "#483d8b", group: "Sunset" },

  // [Candy]
  { name: "Bubblegum", hex: "#ff77ff", group: "Candy" },
  { name: "Cotton Candy", hex: "#ffbcd9", group: "Candy" },
  { name: "Grape", hex: "#6f2da8", group: "Candy" },
  { name: "Lollipop", hex: "#ff1493", group: "Candy" },
  { name: "Blue Raspberry", hex: "#00bfff", group: "Candy" },
  { name: "Cherry", hex: "#de3163", group: "Candy" },
  { name: "Lime Candy", hex: "#bfff00", group: "Candy" },
  { name: "Peach Candy", hex: "#ffb07c", group: "Candy" },
  { name: "Berry", hex: "#8a2be2", group: "Candy" },
  { name: "Sugar", hex: "#fffafa", group: "Candy" },

  // [Galaxy]
  { name: "Cosmic Blue", hex: "#2e2d88", group: "Galaxy" },
  { name: "Nebula Pink", hex: "#ff6fff", group: "Galaxy" },
  { name: "Star Yellow", hex: "#fff44f", group: "Galaxy" },
  { name: "Galaxy Purple", hex: "#6a0dad", group: "Galaxy" },
  { name: "Meteor Red", hex: "#ff2400", group: "Galaxy" },
  { name: "Void", hex: "#0a0a0a", group: "Galaxy" },
  { name: "Starlight", hex: "#f8f8ff", group: "Galaxy" },
  { name: "Orbit", hex: "#4169e1", group: "Galaxy" },
  { name: "Solar", hex: "#ffcc33", group: "Galaxy" },
  { name: "Aurora", hex: "#7fffd4", group: "Galaxy" }
];

// ── Fun facts ─────────────────────────────────────────────────────────────────
// Keyed by colour name. Used in the Colour Inspector section.
export const FUN_FACTS = {
  // Primary
  "Red": "Red is the first colour perceived by the human eye and is associated with energy and urgency.",
  "Blue": "Blue is the world's most popular colour, symbolising trust and calm.",
  "Yellow": "Yellow is the most visible colour to the human eye and is used in warning signs.",
  "Green": "Green is the easiest colour on the eyes and strongly linked to nature and balance.",
  "Orange": "Orange combines the energy of red and the cheerfulness of yellow.",
  "Purple": "Purple was historically reserved for royalty due to the rarity of its dye.",
  "Cyan": "Cyan is a primary colour in printing (CMYK), used worldwide in design.",
  "Magenta": "Magenta doesn’t exist as a wavelength — the brain invents it from red + blue.",
  "Lime": "Lime green became iconic in the 90s tech and gaming industry.",
  "Indigo": "Indigo was added to the rainbow by Isaac Newton — some scientists argue it shouldn’t be there.",

  // Secondary
  "Teal": "Teal is named after a duck with a teal-coloured eye stripe.",
  "Amber": "Amber is fossilised tree resin used in jewellery for thousands of years.",
  "Violet": "Violet has the shortest wavelength of visible light.",
  "Turquoise": "Turquoise is named after the gemstone traded since ancient Persia.",
  "Rose": "Rose has symbolised love and beauty since ancient Greece.",
  "Sky Blue": "Sky blue is caused by Rayleigh scattering of sunlight.",
  "Mint": "Mint green was a popular colour in 1950s kitchen design.",
  "Peach": "Peach became a fashionable colour in early 20th‑century interior design.",
  "Lilac": "Lilac entered English via Persian and French in the 1600s.",
  "Coral": "Coral is named after marine coral skeletons that naturally form warm pink hues.",

  // Warm
  "Crimson": "Crimson comes from a dye made from scale insects.",
  "Scarlet": "Scarlet has long symbolised boldness and passion.",
  "Tomato": "Tomato red is a bright red with a slight orange tint.",
  "Rust": "Rust mimics oxidised iron — a naturally occurring warm red‑brown.",
  "Saffron": "Saffron yellow is derived from the dried stigma of the crocus flower — more expensive than gold by weight.",
  "Tangerine": "Tangerine orange is named after the tangerine fruit, a hybrid of the mandarin orange.",
  "Marigold": "Marigold yellow is named after the marigold flower, used for centuries as a natural dye.",
  "Maroon": "Maroon comes from the French word for chestnut.",
  "Vermilion": "Vermilion was historically made from cinnabar, a mercury mineral.",
  "Fire": "Fire orange mimics the bright glow of flames at high temperature.",

  // Cool
  "Navy": "Navy blue originated from British Royal Navy uniforms in 1748.",
  "Cobalt": "Cobalt blue appears in ancient Chinese pottery.",
  "Cerulean": "Cerulean means 'heavenly blue' in Latin.",
  "Periwinkle": "Periwinkle is named after the small Vinca flower.",
  "Sapphire": "Sapphire blue mirrors the gemstone believed to protect against envy.",
  "Ice Blue": "Ice blue resembles the colour of compressed glacial ice.",
  "Steel Blue": "Steel blue mimics the bluish tint of tempered steel.",
  "Arctic": "Arctic blue evokes polar ice and cold climates.",
  "Lagoon": "Lagoon blue resembles shallow tropical waters.",
  "Deep Sea": "Deep sea blue mimics the near‑black colour of ocean depths.",

  // Neutral
  "Beige": "Beige refers to undyed wool or cotton fabric.",
  "Ivory": "Ivory was historically sourced from elephant tusks.",
  "Cream": "Cream mimics the colour of high‑fat dairy cream.",
  "Khaki": "Khaki means 'dust' in Hindi and Urdu.",
  "Sand": "Sand colour varies globally depending on mineral content.",
  "Taupe": "Taupe comes from the French word for mole.",
  "Caramel": "Caramel forms when sugar is heated to 160°C.",
  "Tan": "Tan refers to leather treated with oak bark.",
  "Wheat": "Wheat colour mimics the golden tone of ripe wheat.",
  "Mushroom": "Mushroom beige resembles the soft tone of mushroom caps.",

  // Dark
  "Black": "Black absorbs all visible wavelengths of light.",
  "Charcoal": "Charcoal grey mimics partially burned wood.",
  "Slate": "Slate grey is named after the rock used for roofing.",
  "Midnight": "Midnight blue resembles the sky just after sunset.",
  "Ebony": "Ebony is a dense black hardwood used in fine instruments.",
  "Burgundy": "Burgundy is named after the French wine region.",
  "Forest": "Forest green evokes dense woodland canopies.",
  "Olive": "Olive green mimics the colour of unripe olives.",
  "Graphite": "Graphite grey resembles the mineral used in pencils.",
  "Onyx": "Onyx black is named after the deep‑black gemstone.",

  // Pastel
  "Pastel Pink": "Pastel pink became iconic in 1980s fashion.",
  "Pastel Blue": "Pastel blue is often used in calming interior palettes.",
  "Pastel Green": "Pastel green evokes freshness and spring.",
  "Pastel Yellow": "Pastel yellow is associated with warmth and optimism.",
  "Pastel Purple": "Pastel purple is linked to creativity and softness.",
  "Pastel Orange": "Pastel orange is used in friendly, playful branding.",
  "Pastel Mint": "Pastel mint is popular in modern UI design.",
  "Pastel Rose": "Pastel rose is widely used in cosmetics branding.",
  "Pastel Lavender": "Pastel lavender evokes calm and relaxation.",
  "Pastel Peach": "Pastel peach is common in soft, warm interior themes.",

  // Earth
  "Clay": "Clay has been used for pottery for over 20,000 years.",
  "Moss": "Moss green resembles the colour of forest moss.",
  "Soil": "Soil brown varies depending on organic content.",
  "Terracotta": "Terracotta means 'baked earth' in Italian.",
  "Stone": "Stone grey mimics natural rock formations.",
  "Driftwood": "Driftwood brown resembles sun‑bleached wood.",
  "Clay Red": "Clay red is common in ancient pottery.",
  "Earth Brown": "Earth brown is one of the most common natural tones.",
  "Harvest": "Harvest gold evokes autumn crops.",
  "Mud": "Mud brown is a deep, cool earth tone.",

  // Metallic
  "Silver": "Silver has been valued since ancient civilisations.",
  "Gold": "Gold is one of the earliest metals used by humans.",
  "Bronze": "Bronze tools revolutionised early human technology.",
  "Copper": "Copper is one of the first metals ever smelted.",
  "Steel": "Steel is an alloy central to modern engineering.",
  "Platinum": "Platinum is rarer than gold and highly corrosion‑resistant.",
  "Titanium": "Titanium is extremely strong and lightweight.",
  "Iron": "Iron has shaped human civilisation since the Iron Age.",
  "Chrome": "Chrome is known for its mirror‑like shine.",
  "Brass": "Brass is used in musical instruments for its resonance.",

  // Fluorescent
  "Neon Yellow": "Neon yellow is used for high‑visibility safety gear.",
  "Neon Orange": "Neon orange is common in emergency signage.",
  "Neon Pink": "Neon pink became iconic in 1980s pop culture.",
  "Neon Green": "Neon green is associated with sci‑fi and digital aesthetics.",
  "Neon Blue": "Neon blue is often used in cyberpunk design.",
  "Neon Purple": "Neon purple evokes futuristic neon lighting.",
  "Neon Red": "Neon red is used in bright LED signage.",
  "Neon Aqua": "Neon aqua appears in retro arcade aesthetics.",
  "Neon Lime": "Neon lime is used in extreme sports branding.",
  "Neon Magenta": "Neon magenta is a staple of vaporwave art.",

  // Monochrome
  "White": "White reflects all wavelengths of visible light.",
  "Light Gray": "Light gray is widely used in modern UI design.",
  "Gray": "Gray is a neutral tone symbolising balance.",
  "Dark Gray": "Dark gray is common in typography for readability.",
  "Jet": "Jet black is named after the gemstone jet.",
  "Ash": "Ash grey resembles volcanic ash.",
  "Smoke": "Smoke grey mimics the colour of rising smoke.",
  "Shadow": "Shadow grey evokes soft, diffused darkness.",
  "Fog": "Fog grey resembles misty atmospheric conditions.",
  "Ink": "Ink black mimics traditional writing ink.",

  // Ocean
  "Wave": "Wave blue resembles ocean surf under sunlight.",
  "Deep Ocean": "Deep ocean blue mimics the near‑black colour of deep water.",
  "Coral Reef": "Coral reef orange reflects tropical marine life.",
  "Seafoam": "Seafoam green resembles foamy ocean water.",
  "Tide": "Tide blue evokes shifting coastal waters.",
  "Blue Lagoon": "Lagoon blue resembles shallow tropical seas.",
  "Abyss": "Abyss black mimics the deepest parts of the ocean.",
  "Foam": "Foam white resembles sea foam bubbles.",
  "Drift": "Drift blue resembles weathered seaside wood.",
  "Shell": "Shell white mimics natural seashells.",

  // Forest
  "Pine": "Pine green resembles evergreen pine needles.",
  "Leaf": "Leaf green mimics fresh spring leaves.",
  "Fern": "Fern green resembles tropical fern plants.",
  "Spruce": "Spruce green is common in winter forests.",
  "Cedar": "Cedar brown mimics the colour of cedar bark.",
  "Bark": "Bark brown resembles tree trunks.",
  "Evergreen": "Evergreen green stays vibrant year‑round.",
  "Moss Green": "Moss green resembles soft forest moss.",
  "Wood": "Wood brown mimics natural timber.",
  "Forest Mist": "Forest mist green evokes foggy woodland mornings.",

  // Sunset
  "Sunset Orange": "Sunset orange resembles the sky during golden hour.",
  "Sunset Pink": "Sunset pink appears during warm evening skies.",
  "Sunset Purple": "Sunset purple forms when sunlight scatters at dusk.",
  "Sunset Yellow": "Sunset yellow evokes warm evening light.",
  "Sunset Red": "Sunset red appears when dust scatters sunlight.",
  "Dusk": "Dusk purple resembles twilight skies.",
  "Twilight": "Twilight blue appears after sunset.",
  "Glow": "Glow peach resembles warm glowing clouds.",
  "Horizon": "Horizon peach evokes distant sunset views.",
  "Evening": "Evening blue resembles the sky before nightfall.",

  // Candy
  "Bubblegum": "Bubblegum pink is inspired by classic bubblegum.",
  "Cotton Candy": "Cotton candy pink mimics the carnival treat.",
  "Grape": "Grape purple resembles grape‑flavoured sweets.",
  "Lollipop": "Lollipop pink evokes bright candy colours.",
  "Blue Raspberry": "Blue raspberry is a flavour invented for colour appeal.",
  "Cherry": "Cherry red resembles the fruit and candy flavour.",
  "Lime Candy": "Lime candy green evokes citrus sweets.",
  "Peach Candy": "Peach candy orange resembles fruity treats.",
  "Berry": "Berry purple mimics mixed berry flavours.",
  "Sugar": "Sugar white resembles powdered sugar.",

  // Galaxy
  "Cosmic Blue": "Cosmic blue evokes deep interstellar space.",
  "Nebula Pink": "Nebula pink resembles glowing nebula clouds.",
  "Star Yellow": "Star yellow mimics the colour of bright starlight.",
  "Galaxy Purple": "Galaxy purple appears in cosmic dust clouds.",
  "Meteor Red": "Meteor red resembles burning meteors entering the atmosphere.",
  "Void": "Void black represents the emptiness of space.",
  "Starlight": "Starlight white resembles bright stars.",
  "Orbit": "Orbit blue evokes planetary motion.",
  "Solar": "Solar yellow resembles sunlight at peak intensity.",
  "Aurora": "Aurora green mimics the northern lights."
};
